import { BoxIndicator } from '@classtinginc/design-system';
import loadable from '@loadable/component';

const Classroom = loadable(() => import('./Classroom'), {
  fallback: <BoxIndicator />,
});

export default Classroom;
